import { ActiveNoCoachReasons } from '@amzn/aet-coachingform-kit/lib/types';
import { IntlShape } from 'react-intl';

import { NoCoachReasonsObject } from '../../../api/CoachingForm/schema';
import { getObjectOptions } from '../FieldComponents/Helpers';
import { Option } from '../FieldComponents/Select';

export const getAllReasonOptions = (intl: IntlShape): Option[] => {
  const translations: Record<string, string> = {
    [NoCoachReasonsObject.LOA]: intl.formatMessage({
      id: 'cs_perfportal_coaching_nosession_options_reason_csa_on_leave',
      defaultMessage: 'Associate on leave',
    }),
    [NoCoachReasonsObject.LEAVING]: intl.formatMessage({
      id: 'cs_perfportal_coaching_nosession_options_reason_csa_not_on_team',
      defaultMessage: 'Associate leaving / not on the team',
    }),
    [NoCoachReasonsObject.UNABLE]: intl.formatMessage({
      id: 'cs_perfportal_coaching_nosession_options_reason_csa_no_attend',
      defaultMessage: "Associate unable to attend / didn't attend",
    }),
    [NoCoachReasonsObject.NEW]: intl.formatMessage({
      id: 'cs_perfportal_coaching_nosession_options_reason_csa_just_joined',
      defaultMessage: 'Associate just joined / returning',
    }),
    [NoCoachReasonsObject.RESCHEDULED]: intl.formatMessage({
      id: 'cs_perfportal_coaching_nosession_options_reason_rescheduled',
      defaultMessage: 'Rescheduled for later due to other events / priorities',
    }),
    [NoCoachReasonsObject.OTHER]: intl.formatMessage({
      id: 'cs_perfportal_other',
      defaultMessage: 'Other',
    }),
  };

  return getObjectOptions(NoCoachReasonsObject, translations);
};

export const getReasonOptions = (intl: IntlShape): Option[] => {
  return getAllReasonOptions(intl).filter(
    reason => reason.value in ActiveNoCoachReasons
  );
};
